<template>
  <div class="row documents" id="scan-copy-block" v-if="enableScanCopy">
    <div class="col-md-12 col-sm-12 col-xs-12" v-if="form.application.status === 'awaiting_signing'">
      <p style="margin: 0 0 10px">
        Для подачи заявки подпишите её квалифицированной электронной подписью (подойдет подпись,
        которой подписываются документы организации при сдаче налоговой отчетности в электронном
        виде или для работы на электронных торговых площадках). Для этого нажмите на кнопку
        «Подписать КЭП и подать».
      </p>
      <p
        v-if="form.application.status === 'awaiting_signing' && canAttachScanCopy"
        style="margin: 0 0 10px"
      >
        В качестве альтернативы загрузите ниже скан-копию распечатанной заявки, заверенной подписью руководителя и
        печатью организации. Затем нажмите на кнопку «Подать без КЭП».
      </p>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 panel-group">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h2 class="panel-title">
            <b-button v-b-toggle.scan-copy-panel-body class="btn btn-link btn-collapse"
                      style="width: auto"
            >
              Скан-копия заявки
            </b-button>
          </h2>
        </div>

        <b-collapse id="scan-copy-panel-body" class="panel-collapse">
          <div class="panel-body">
              <dashboard
                v-if="isView && form.application.status === 'awaiting_signing'"
                id="dashboard"
                :uppy="uppy"
                :plugins="['ImageEditor']"
                :props="dashboardOptions"
              ></dashboard>
              <div v-if="isView && form.application.status !== 'awaiting_signing'">
                <CoolLightBox
                  :items="form.scanCopiesUrls || []"
                  :index="scanCopyPreviewIndex"
                  :useZoomBar="true"
                  @close="scanCopyPreviewIndex = null"
                >
                </CoolLightBox>
                <div class="image-review"
                     style="display: inline-flex; flex-direction: row; flex-wrap: wrap;"
                >
                  <div
                    class="image"
                    v-for="(image, imageIndex) in form.scanCopiesUrls || []"
                    :key="imageIndex"
                    @click="scanCopyPreviewIndex = imageIndex"
                    :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                    style="width: 100px; height: 100px; display: inline; margin: 5px; background-repeat: no-repeat; background-size: 100px; background-position: center"
                  ></div>
                </div>
              </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import '@uppy/image-editor/dist/style.css'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import Vue from 'vue'
import CoolLightBox from 'vue-cool-lightbox'
import mainMixin from '../../common/mixins/mainMixin'
import applicationFormMixin from '../../common/mixins/applicationFormMixin'
import applicationFormContextMixin from '../../common/mixins/applicationFormContextMixin'
import RusUppy from '@uppy/locales/lib/ru_RU'
import Uppy from '@uppy/core'
import { Dashboard } from '@uppy/vue'
import ImageEditor from '@uppy/image-editor'
import XHRUpload from '@uppy/xhr-upload'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import { BaseApiClient } from '@/common/helpers/BaseApiClient'

Vue.component('dashboard', Dashboard)

export default {
  name: 'ScanCopyFormBlock',

  model: {
    prop: 'hasUploadedScanCopy',
    event: 'change'
  },

  props: {
    hasUploadedScanCopy: {
      type: Boolean,
      default: () => false
    }
  },

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin
  ],

  components: {
    CoolLightBox
  },

  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    apiUrl: process.env.VUE_APP_API_URL,
    enableUserSign: process.env.VUE_APP_ENABLE_USER_SIGN,
    enableScanCopy: process.env.VUE_APP_SCAN_COPY,
    scanCopyPreviewIndex: null,
    dashboardOptions: {
      width: '100%',
      height: 340,
      inline: true,
      showProgressDetails: true,
      doneButtonHandler: null,
      showRemoveButtonAfterComplete: true,
      proudlyDisplayPoweredByUppy: false,
      target: '.DashboardContainer',
      replaceTargetContent: true,
      note: 'Изображения и pdf до 20Мб',
      browserBackButtonClose: false,
      showLinkToFileUploadResult: true
    }
  }),

  methods: {
    setUploadedScanCopyStatus (value) {
      this.model = value
    },

    sendDeleteRequestForFile (file) {
      axios({
        method: 'post',
        url: this.apiUrl + '/upload/remove-app-scan',
        headers: BaseApiClient.getAuthHeaders(),
        data: {
          fileName: file.name,
          applicationNumber: file.meta.applicationNumber
        }
      })
    },

    dataURItoBlob (dataURI, mimeString) {
      const byteString = atob(dataURI)

      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // write the ArrayBuffer to a blob, and you're done
      return new Blob([ab])
    }
  },

  computed: {
    model: {
      get () {
        return this.hasUploadedScanCopy
      },

      set (value) {
        this.$emit('change', value)
      }
    },

    canAttachScanCopy() {
      return Number(this.configuration.can_attach_scancopy) === 1
    },

    uppy () {
      if (this.isView && this.form.application.status === 'awaiting_signing') {
        RusUppy.strings.done = 'Назад'

        return new Uppy(
          {
            width: '100%',
            locale: RusUppy,
            allowMultipleUploads: true,
            autoProceed: true,
            debug: false,
            restrictions: {
              maxFileSize: 1024 * 1024 * 20,
              minFileSize: null,
              maxTotalFileSize: null,
              maxNumberOfFiles: null,
              minNumberOfFiles: 1,
              allowedFileTypes: ['image/*', '.pdf']
            },
            onBeforeFileAdded: (currentFile, files) => {
              if (currentFile.remote !== true) {
                const ext = currentFile.name.split('.').pop()
                const name = uuidv4() + '.' + ext

                return {
                  ...currentFile,
                  name,
                  meta: {
                    ...currentFile.meta,
                    name
                  }
                }
              }
            }
          }
        ).use(ImageEditor, {
          trigger: '#dashboard',
          quality: 1,
          actions: {
            revert: true,
            rotate: true,
            flip: true,
            zoomIn: true,
            zoomOut: true,
            cropSquare: false,
            cropWidescreen: false,
            cropWidescreenVertical: false
          },
          locale: {
            strings: {
              save: 'Сохранить',
              revert: 'Вернуть к исходному состоянию',
              rotate: 'Повернуть',
              flipHorizontal: 'Отразить по горизонтали',
              zoomIn: 'Увеличить',
              zoomOut: 'Уменьшить'
            }
          }
        }).use(XHRUpload, {
          limit: 10,
          headers: BaseApiClient.getAuthHeaders(),
          endpoint: this.apiUrl + '/upload/signed-app',
          formData: true,
          fieldName: 'file'
        })
      }

      return null
    },

    isUppyUpload () {
      let isUploaded = false
      const files = this.uppy.getFiles()
      if (files) {
        for (const file of files) {
          isUploaded = file.progress.uploadComplete
          if (isUploaded === false) {
            break
          }
        }
      }

      return isUploaded
    }
  },

  created () {
    if (this.enableUserSign && this.isView && this.form.application.status === 'awaiting_signing') {
      const appNumber = this.form.application.number
      axios({
        method: 'get',
        url: this.apiUrl + '/get-file/scan-copy-blob?applicationId=' + this.form.application.id,
        headers: BaseApiClient.getAuthHeaders()
      })
        .then(result => {
          if (Number(result.status) === 200) {
            const files = result.data.data
            files.forEach(file => {
              const id = this.uppy.addFile({
                name: file.name,
                type: file.type,
                data: this.dataURItoBlob(file.data, file.type),
                size: file.size,
                remote: true
              })
              this.uppy.setFileState(id, {
                progress: { uploadComplete: true, uploadStarted: true }
              })
              this.uppy.setFileState(id, {
                uploadURL: this.baseUrl + '/get-file/scan-copy' +
                  '?filename=' + file.name +
                  '&applicationId=' + this.form.application.id
              })
              this.setUploadedScanCopyStatus(true)
            }
            )
          }
        })
      this.uppy.on('file-removed', (file, reason) => {
        if (reason === 'removed-by-user') {
          this.sendDeleteRequestForFile(file)
          this.setUploadedScanCopyStatus(this.isUppyUpload)
        }
      })

      this.uppy.on('upload-success', (file, data, uploadUrl) => {
        this.uppy.setFileState(file.id, {
          uploadURL: this.baseUrl + '/get-file/scan-copy' +
            '?filename=' + file.name +
            '&applicationId=' + this.form.application.id
        })
        this.setUploadedScanCopyStatus(this.isUppyUpload)
      })

      this.uppy.on('file-added', (file) => {
        this.uppy.setFileMeta(file.id, {
          applicationNumber: appNumber
        })
      })
    }
    return null
  }
}
</script>
